
import { Field, Popup, TreeSelect, Picker, NumberKeyboard, Uploader } from 'vant'
// 引用车辆信息 20190815
import { carInfo } from '../../../assets/js/car'
// 引入公共文件
import { formCheck, stringFn } from '../../../assets/js/xjpublic'
import { errorModal } from '../../../assets/js/xjcommon';
import { jsSdk } from '../../../assets/libs/loadjs';
import * as qiniu from 'qiniu-js'

export default {
  name: 'home',
  components: {
    [Field.name]: Field,
    [Popup.name]: Popup,
    [TreeSelect.name]: TreeSelect,
    [Picker.name]: Picker,
    [NumberKeyboard.name]: NumberKeyboard,
    [Uploader.name]: Uploader
  },
  data () {
    return {
      // 页面进度
      progress: 0,
      nowIccid: '',
      notPassText: '',
      // 提交
      realName: '',
      idCard: '',
      // 文件
      handCardFile: null,
      frontCardFile: null,
      backCardFile: null,
      // 上传到七牛云之后返回的图片地址
      handCardUrl: '',
      frontCardUrl: '',
      backCardUrl: '',
      // licenseUrl: '',
      loadingSubmit: false
    }
  },
  methods: {
    // 获取实名认证的信息
    initGetRealNameFn () {
      let _this = this;
      this.$toast.loading({
        mask: true,
        duration: 0,
        message: '加载中...'
      });
      // 传入ICCID是因为从模板消息中进入可能不是当前默认设备的ICCID
      this.$axios.post('/sim/getRealInfo', { iccid: this.nowIccid })
        .then(function (response) {
          if (response.data.ret === 0) {
            // 关闭加载状态
            _this.$toast.clear();
            if (response.data.data.iccid) {
              _this.nowIccid = response.data.data.iccid;
            }
            if (response.data.data.realName) {
              _this.realName = response.data.data.realName;
            }
            if (response.data.data.idNumber) {
              _this.idCard = response.data.data.idNumber;
            }
            if (response.data.data.status === 'unsubmitted') {
              _this.progress = 1;
            } else if (response.data.data.status === 'checking') {
              _this.progress = 3;
            } else if (response.data.data.status === 'ok') {
              _this.progress = 4;
            } else if (response.data.data.status === 'reject') {
              _this.progress = 5;
              _this.notPassText = response.data.data.reason;
            } else if (response.data.data.status === 'exception') {
              _this.progress = 6;
            }
          } else {
            _this.$toast.clear();
            _this.$dialog({
              message: response.data.msg ? response.data.msg + '（' + response.data.ret + '）' : '获取实名认证信息失败（' + response.data.ret + '）'
            })
          }
        })
        .catch(function (error) {
          _this.$toast.clear();
          errorModal(error, 541);
        })
    },
    nextStepFn () {
      if (!this.nowIccid) {
        this.$toast('当前设备未插入SIM卡');
        return
      }
      if (!stringFn.trim(this.realName)) {
        this.$toast('请输入真实姓名');
        return
      }
      if (!this.idCard) {
        this.$toast('请输入身份证号码');
        return
      }
      if (!formCheck.checkCard(this.idCard)) {
        this.$toast('身份证号码错误');
        return
      }
      this.nextStepSubmitFn();
    },
    nextStepSubmitFn () {
      this.progress = 2;
    },
    prevStepFn () {
      this.progress = 1;
    },
    resubmitFn () {
      this.realName = '';
      this.idCard = '';
      this.progress = 1;
    },
    // 上传文件
    beforeRead(file) {
      if (file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/jpg') {
        this.handCardFile = file;
      } else {
        this.$dialog({
          message: '手持图片格式错误'
        });
      }
      return false;
    },
    beforeReadFront(file) {
      if (file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/jpg') {
        this.frontCardFile = file;
      } else {
        this.$dialog({
          message: '正面图片格式错误'
        });
      }
      return false;
    },
    beforeReadBack(file) {
      if (file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/jpg') {
        this.backCardFile = file;
      } else {
        this.$dialog({
          message: '反面图片格式错误'
        });
      }
      return false;
    },
    // 绑定前检查
    realNameCheckFn () {
      if (!this.handCardFile) {
        return this.$toast('请上传手持身份证照片');
      }
      if (!this.frontCardFile) {
        return this.$toast('请上传身份证正面照片');
      }
      if (!this.backCardFile) {
        return this.$toast('请上传身份证反面照片');
      }
      this.loadingSubmit = true;
      this.$toast.loading({
        mask: true,
        duration: 0,
        message: '提交中...'
      });
      this.realNameGetQiniuFn('first', this.handCardFile);
    },
    // 绑定设备信息 通过我们后台获取七牛云Token,参数type1为图片,2为视频
    realNameGetQiniuFn (scene, file) {
      let _this = this;
      this.$axios.post('/resource/getUploadTokenByUser', { type: 1 })
        .then(function (response) {
          if (response.data.ret === 0) {
            let qiniuToken = response.data.data.token;
            let qiniuBaseUrl = response.data.data.baseUrl;
            let qiniuUrl = response.data.data.url;
            _this.realNameUpFailFn(qiniuToken, qiniuBaseUrl, qiniuUrl, scene, file);
          } else {
            _this.loadingSubmit = false;
            _this.$toast.clear();
            _this.$dialog({
              message: response.data.msg ? response.data.msg + '（' + response.data.ret + '）' : '操作失败（' + response.data.ret + '）'
            })
          }
        })
        .catch(function (error) {
          _this.loadingSubmit = false;
          _this.$toast.clear();
          errorModal(error, 542);
        })
    },
    // 绑定设备信息 上传行驶证图片到七牛云,上传成功后返回地址
    realNameUpFailFn (qiniuToken, qiniuBaseUrl, qiniuUrl, scene, file) {
      let _this = this;
      let putExtra = {
        // 文件原文件名
        fname: file.name,
        // 用来放置自定义变量
        params: {},
        // 用来限制上传文件类型，为 null 时表示不对文件类型限制
        mimeType: ['image/png', 'image/jpeg', 'image/jpg', 'image/JPG']
      };
      let config = {
        // 表示是否使用 cdn 加速域名，为布尔值，true 表示使用，默认为 false
        useCdnDomain: true,
        // 选择上传域名区域；当为 null 或 undefined 时，自动分析上传域名区域
        region: null
      };
      let observer = {
        next (res) {
          // 接收上传进度信息
          // console.log(res);
        },
        error (error) {
          // 上传错误后触发
          _this.loadingSubmit = false;
          _this.$toast.clear();
          errorModal(error, 543);
        },
        complete (res) {
          // 接收上传完成后的后端返回信息,res 参数为一个 object,为上传成功后后端返回的信息,具体返回结构取决于后端sdk的配置
          console.log(qiniuBaseUrl + '/' + res.key);
          if (scene === 'first') {
            _this.handCardUrl = qiniuBaseUrl + '/' + res.key;
            _this.realNameGetQiniuFn('second', _this.frontCardFile)
          } else if (scene === 'second') {
            _this.frontCardUrl = qiniuBaseUrl + '/' + res.key;
            _this.realNameGetQiniuFn('third', _this.backCardFile)
          } else if (scene === 'third') {
            _this.backCardUrl = qiniuBaseUrl + '/' + res.key;
            _this.realNameSubmitFn();
          }
        }
      };
      let observable = qiniu.upload(file, qiniuUrl, qiniuToken, putExtra, config);
      let subscription = observable.subscribe(observer);
    },
    // 提交所有信息
    realNameSubmitFn () {
      let _this = this;
      this.$axios.post('/sim/uploadRealInfo', {
        iccid: this.nowIccid,
        realName: stringFn.trim(this.realName),
        idNumber: this.idCard,
        handCardUrl: this.handCardUrl,
        frontCardUrl: this.frontCardUrl,
        backCardUrl: this.backCardUrl,
      }).then(function( response ){
        _this.loadingSubmit = false;
        _this.$toast.clear();
        if (response.data.ret === 0) {
          _this.$toast('提交成功！');
          _this.progress = 3;
        } else {
          _this.$dialog({
            message: response.data.msg ? response.data.msg + '（' + response.data.ret + '）' : '提交失败（' + response.data.ret + '）'
          });
        }
      }).catch(function(error){
        _this.loadingSubmit = false;
        _this.$toast.clear();
        errorModal(error, 544);
      });
    },
    toLinkFn () {
      // ios系统会唤醒途云APP
      // window.location.href = 'http://ys.spreadwin.com/index.php/Home/Authentication/auth_desc.html';
      this.$router.push('/RealNameAgree');
    },
    // 跳转到首页
    toHomePageFn () {
      this.$router.push('/')
    },
  },
  created () {

  },
  mounted () {
    // 模板消息是带iccid参数的
    this.nowIccid = this.$route.query.iccid || '';
    this.initGetRealNameFn();
  }
}
